import Immutable from 'immutable';
import { createSelector } from 'reselect';

const metaSelector = (state) => state.Metas;

export const metaByIdentifierSelector = createSelector(
  [metaSelector],
  (metas) => {
    return metas.get('byIdentifier', Immutable.Map());
  }
);

export const makeMetaSelectorByIdentifier = (identifier) =>
  createSelector(
    [metaByIdentifierSelector],
    (metasByIdentifier) => {
      return metasByIdentifier.get(
        identifier,
        Immutable.Map({
          loading: false,
          error: false,
        })
      );
    }
  );
